import clsx from 'clsx';
import React from 'react';

interface Props {
  title: string;
  children?: React.ReactNode;
  className?: string;
}

export const FieldInformation = ({ title, children, className }: Props) => {
  if(!children) return null;
  
  return (
    <div className={clsx("flex gap-2 text-[14px]", className)}>
      <strong>{title}</strong>
      {children}
    </div>
  );
};

